import { PageHeader } from 'teacher-ui-client/components/page-header'
import writingLegendsDeviceMockup from '@images/writing-legends-device-mockup.png'
import writingLegendsCoinSvg from '@images/logos/wl-coin-logo.svg'
import writingLegendsAvatarCrouching from '@images/writing-legend-crouching.png'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { t } from 'ember-intl'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import type { TOC } from '@ember/component/template-only'

export const RenewTrial: TOC<unknown> = <template>
  <div class="grow">
    <PageHeader>
      <:title>
        <h1>
          {{t "pages.renewTrial.writingLegends.title"}}
        </h1>
      </:title>

    </PageHeader>
    <div class="mx-auto max-w-(--breakpoint-md)">
      <div>
        {{t "pages.renewTrial.writingLegends.accessExpired" htmlSafe=true}}
        <br />
        <br />
      </div>
      <div class="mb-8">
        {{t "pages.renewTrial.writingLegends.trialExtension" htmlSafe=true}}
      </div>
      <div class="mb-12 flex justify-center">
        <UiButtonLinkTo
          @appearance={{ButtonAppearance.regular}}
          @route="subscription-type.contact-us"
          data-test-contact-us
        >
          {{t "pages.renewTrial.writingLegends.contactUsButton"}}
        </UiButtonLinkTo>
      </div>
      <div class="mb-10 flex items-center justify-center">
        <img
          src={{writingLegendsDeviceMockup}}
          class="h-64"
          alt={{t "pages.renewTrial.writingLegends.deviceMockups"}}
        />
      </div>
      <h4 class="text-oceany-blue-325 mb-8 text-center">
        {{t "pages.renewTrial.writingLegends.freeTrial.title"}}
      </h4>
      <div class="mb-8">
        <div class="space-y-7">
          <div class="flex">
            <img
              src={{writingLegendsCoinSvg}}
              class="mr-2 inline-block h-8"
              alt={{t "pages.renewTrial.writingLegends.freeTrial.coinLogo"}}
            />
            <div>
              {{t "pages.renewTrial.writingLegends.freeTrial.unlimitedAccess" htmlSafe=true}}
            </div>

          </div>
          <div class="flex">
            <img
              src={{writingLegendsCoinSvg}}
              class="mr-2 inline-block h-8"
              alt={{t "pages.renewTrial.writingLegends.freeTrial.coinLogo"}}
            />
            <div>
              {{t "pages.renewTrial.writingLegends.freeTrial.accountManager" htmlSafe=true}}
            </div>
          </div>
          <div class="flex">
            <img
              src={{writingLegendsCoinSvg}}
              class="mr-2 inline-block h-8"
              alt={{t "pages.renewTrial.writingLegends.freeTrial.coinLogo"}}
            />
            <div>
              {{t "pages.renewTrial.writingLegends.freeTrial.studentImpact" htmlSafe=true}}
            </div>
          </div>

        </div>

      </div>
      <div class="mb-8 flex items-center justify-center">
        <img src={{writingLegendsAvatarCrouching}} class="w-32" alt={{t "pages.renewTrial.writingLegends.avatar"}} />
      </div>

      <div class="mb-4">
        {{t "pages.renewTrial.writingLegends.note" htmlSafe=true}}
      </div>
      <div class="mb-12 flex justify-center">
        <UiButtonLinkTo
          @appearance={{ButtonAppearance.regular}}
          @route="subscription-type.contact-us"
          data-test-contact-us
        >
          {{t "pages.renewTrial.writingLegends.contactUsButton"}}
        </UiButtonLinkTo>
      </div>
    </div>
  </div>
</template>

export default RenewTrial
